import { ActionBase } from '../../../../core/store/action/ActionBase';

export function deleteType<TModel>(module: string, type: { new(): TModel; }): string {
  return `[${module}] Delete ${(type as any).$typeName}`;
}

export class DeleteAction<TModel> implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }, public payload: { model: TModel }) {
    this.type = deleteType(module, modelType);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/actions/DeleteAction.ts